import { render, staticRenderFns } from "./estimateDetail.vue?vue&type=template&id=2da74084&scoped=true&"
import script from "./estimateDetail.vue?vue&type=script&lang=ts&"
export * from "./estimateDetail.vue?vue&type=script&lang=ts&"
import style0 from "./estimateDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./estimateDetail.vue?vue&type=style&index=1&id=2da74084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da74084",
  null
  
)

export default component.exports